import { render, staticRenderFns } from "./examenFisicoShow.vue?vue&type=template&id=409f1b70"
import script from "./examenFisicoShow.vue?vue&type=script&lang=js"
export * from "./examenFisicoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports